import { SOURCE_ACTIONS } from "./SOURCE_ACTIONS"


export function sourceReducer(state, action) {
  switch (action.type) {
    case SOURCE_ACTIONS.SET_SOURCE:
      return {
        ...state,
        source: action.payload.source,
      }
    case SOURCE_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}